export default function initStrategyGrid() {
    // ==========================================================
    // STRATEGY GRID
    // ==========================================================

    const strategyGrids = document.querySelectorAll("[data-strategy-grid]");

    strategyGrids.forEach((grid) => {
        const mainCard = grid.querySelector("[data-strategy-main]");

        const choicesWrapper = grid.querySelector("[data-strategy-choices]");

        if (!mainCard || !choicesWrapper) {
            return;
        }

        const iconWrapper = mainCard.querySelector("[data-strategy-icon-wrapper]");

        const icon = mainCard.querySelector("[data-strategy-icon]");

        const title = mainCard.querySelector("[data-strategy-title]");

        const content = mainCard.querySelector("[data-strategy-content]");

        const buttonWrapper = mainCard.querySelector("[data-strategy-button-wrapper]");

        const button = mainCard.querySelector("[data-strategy-button]");

        const getCardData = (element) => ({
            icon: element.dataset.icon || "",
            title: element.dataset.title || "",
            content: element.dataset.content || "",
            buttonText: element.dataset.buttonText || "",
            buttonUrl: element.dataset.buttonUrl || "",
        });

        const setCardData = (element, data) => {
            element.dataset.icon = data.icon || "";

            element.dataset.title = data.title || "";

            element.dataset.content = data.content || "";

            element.dataset.buttonText = data.buttonText || "";

            element.dataset.buttonUrl = data.buttonUrl || "";
        };

        const renderMainCard = () => {
            const data = getCardData(mainCard);

            // ICON

            if (data.icon) {
                icon.src = data.icon;

                iconWrapper.hidden = false;
            } else {
                icon.removeAttribute("src");

                iconWrapper.hidden = true;
            }

            // TITLE

            title.textContent = data.title;

            // CONTENT

            content.innerHTML = data.content;

            // BUTTON

            if (data.buttonText && data.buttonUrl) {
                button.textContent = data.buttonText;

                button.href = data.buttonUrl;

                buttonWrapper.hidden = false;
            } else {
                buttonWrapper.hidden = true;
            }
        };

        choicesWrapper.addEventListener("click", (event) => {
            const choice = event.target.closest("[data-strategy-choice]");

            if (!choice) {
                return;
            }

            // Sauvegarde ancienne carte principale

            const oldMainData = getCardData(mainCard);

            // Données de la carte cliquée

            const clickedData = getCardData(choice);

            // La petite carte devient la principale

            setCardData(mainCard, clickedData);

            // L'ancienne principale prend
            // la place de la petite carte

            setCardData(choice, oldMainData);

            // Mise à jour du titre visible
            // de la petite carte

            const choiceTitle = choice.querySelector(".strategy-grid__card-title");

            if (choiceTitle) {
                choiceTitle.textContent = oldMainData.title;
            }

            // Mise à jour carte principale

            renderMainCard();
        });
    });
}
